<template>
    <div>
        <v-form ref="editCadConfigurationForm" @submit="save" onSubmit="return false">
            <v-container fluid>
                <v-layout>
                    <v-flex md12>
                        <v-text-field counter="100" label="Description" v-model="config.description"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex md3>
                        <v-text-field counter="100" label="CAD URL" v-model="config.url" :rules="requiredValidation('URL')"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field counter="100" label="CAD Tenant" v-model="config.tenant" :rules="requiredValidation('Tenant')"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field counter="100" label="CAD Username" v-model="config.userName" :rules="requiredValidation('User Name')"></v-text-field>
                    </v-flex>
                    <v-flex md3>
                        <v-text-field counter="100" type="password" label="CAD Password" v-model="config.password" :rules="requiredValidation('Password')"></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-btn outlined class="mx-2" type="button" @click="test()" color="primary" :disabled="overlay">Test</v-btn>
                    <v-btn outlined  type="button" @click="save()" color="success" :disabled="overlay">Save</v-btn>
                    <v-progress-circular
                            :width="3"
                            v-show="overlay"
                            color="red"
                            indeterminate="">
                    </v-progress-circular>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<script>
    import api from '@/api';
    import {validationMixin} from '@/mixins/validations'

    export default {
        name:'EditCadConfiguration',
        mixins:[validationMixin],
        data() {
            return {
                config: {},
                overlay : false,
                violations : []
            }
        },
        mounted() {
            this.$root.$emit('showGlobalOverlay');
            api.cadConfig.get(this.$route.params.configId).then((config) => this.config = config).finally(() => {
                this.$root.$emit('hideGlobalOverlay');
            });
        },
        methods: {
            save() {
                this.overlay = true;
                this.violations = [];
                api.cadConfig.patch(this.config).then((config) => {
                    this.config = config;
                    this.$root.$emit('globalMessage','CAD Configuration Updated');
                },(error) => {
                    if (this.processErrors(error) == this.RESPONSE_VALIDATION) {
                        this.$refs.editCadConfigurationForm.validate();
                    }
                }).finally(() => {
                    this.overlay = false;
                });

            },
            test() {
                this.overlay = true;
                api.helpers.testCadConnection(this.config).then((result) => {
                    console.log(result);
                    const success = (result && result.type == 'SUCCESS');
                    if (success) {
                        this.$root.$emit('globalMessage','Test Successful');
                    } else {
                        const statusCode = (result && result.statusCode) || '';
                        const statusText = (result && result.statusText) || '';
                        const body = (result && result.body) || '';
                        this.$root.$emit('globalError',`Test Failed [Status Code=${statusCode}, Status Text=${statusText}, Body=${body}]`);
                    }
                },() => {
                    this.$root.$emit('globalError','Error Executing Test');
                }).finally(() => {
                    this.overlay = false;
                })
            },
            goBack() {

            }
        }
    }

</script>